import { create, destroy, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

import { SlidingPane } from '@holmescorp/base-widgets/sliding-pane';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { subscribe } from 'pub-sub';
import { createNlsMiddleware, registry } from 'lcc-state';

import { delay } from '@holmescorp/common';
import { viewport } from '../support/viewport';

interface ProgressPaneProperties {
	onClose?: () => void;
}

interface ProgressPaneIcache {
	open: boolean;
	aboutToChange: boolean;
}

const icache = createICacheMiddleware<ProgressPaneIcache>();
const nls = createNlsMiddleware('settings');
const factory = create({
	icache,
	destroy,
	theme,
	nls
}).properties<ProgressPaneProperties>();

export const ProgressPane = factory(({ properties, middleware: { icache, destroy, nls } }) => {
	const { onClose } = properties();

	icache.getOrSet('aboutToChange', false);
	const open = icache.getOrSet('open', () => {
		const hnd = [
			subscribe('progress/open', async () => {
				icache.set('aboutToChange', true);
				await delay(200);
				icache.set('open', true);
			}),
			subscribe('close-all/panes', () => {
				icache.set('open', false);
			})
		];
		destroy(() => {
			hnd.forEach((h) => h.destroy());
		});
		return false;
	});

	const {
		messages: { progress_title = '[settings] progress_title' }
	} = nls();

	const { vw } = viewport();
	const xqa = `progress-pane-${open}`;

	return w(
		SlidingPane,
		{
			xqa,
			key: 'progress-pane',
			open,
			align: 'right',
			underlay: true,
			title: progress_title,
			width: Math.min(vw, 512),
			onRequestClose: () => {
				icache.set('open', false);
				icache.set('aboutToChange', async () => {
					await delay(500);
					return true;
				});
				onClose && onClose();
			}
		},
		[w('TopicProgress', {})]
	);
});

registry.define('ProgressPane', ProgressPane);
